import { useMutation, useQueryClient } from 'react-query';
import { ExperimentTemplatePreview } from '@experiment-details/types';
import { expDetailsTemplateKeys } from '../api/exp-details-template-key-factory';
import chartApi from '@/util/experimentDetails/chartApi';
import useExpDetailsRouteParams from '../useExpDetailsRouteParams';

export default function useSetDefaultExpDetailsTemplate() {
  const { projectId } = useExpDetailsRouteParams();
  const queryClient = useQueryClient();

  return useMutation(
    (templateId?: string | null) =>
      chartApi.setProjectTemplate({
        project_id: projectId,
        template_id: templateId || null
      }),
    {
      onMutate: async templateId => {
        const listQueryKey = expDetailsTemplateKeys.templateList(projectId);
        const prevData: ExperimentTemplatePreview[] =
          queryClient.getQueryData(listQueryKey) || [];

        queryClient.setQueryData(listQueryKey, [
          ...prevData.map(oldTemplate => {
            if (oldTemplate.templateId !== templateId) {
              return {
                ...oldTemplate,
                is_default: true
              };
            }

            if (!templateId && oldTemplate.personalView) {
              return {
                ...oldTemplate,
                is_default: true
              };
            }

            return oldTemplate;
          })
        ]);

        return { prevData };
      },
      onError: (e, _, context) => {
        queryClient.setQueryData(
          expDetailsTemplateKeys.templateList(projectId),
          context?.prevData
        );
      },
      onSuccess: async () => {
        await queryClient.invalidateQueries(
          expDetailsTemplateKeys.templateList(projectId),
          {
            refetchInactive: true
          }
        );
      }
    }
  );
}
